module.exports = __webpack_public_path__ + "media/images/job2_icon-a32b6c24f3f491fa4b109f2554949f68.png";